/**
 * Read gate flags from login / refresh payloads.
 * Returns undefined when the key is absent so callers can skip state updates
 * for partial responses.
 *
 * Checks user-level first (d.user.X), then top-level (d.X).
 */

function readFlag(payload, key) {
  if (!payload || typeof payload !== "object") return undefined;
  if (
    payload.user != null &&
    Object.prototype.hasOwnProperty.call(payload.user, key)
  ) {
    return !!payload.user[key];
  }
  if (Object.prototype.hasOwnProperty.call(payload, key)) {
    return !!payload[key];
  }
  return undefined;
}

export function readPasswordChangeRequiredFromPayload(payload) {
  return readFlag(payload, "password_change_required");
}

export function readEmailVerificationFromPayload(payload) {
  return readFlag(payload, "email_verification_code_sent");
}
